import React from 'react'
import "./features.css"
import { Feature } from '../../components'

const featuresData = [
  {
    title : "Improving end distrusts instantly ",
    text : "Whether you're looking to tackle complex algebra problems or simple math problems that are too tricky to piece together, ChatGPT is particularly strong in handling math.",
  },
  {
    title : "Write, Debug, and Explain Code",
    text : "Whether you're an experienced programmer or a newbie, you're bound to run into a few bugs in your code from time to time.",
  }, 
  {
    title : "Message or am nothing",
    text : "If you're a content creator that would love to reach a wider audience, ChatGPT could be incredibly useful for creating content in multiple languages.",
  },
  {
    title : "A Chat Companion",
    text : "When all is said and done, ChatGPT is an AI chatbot. Despite its almost endless use cases, you'll find ChatGPT a very accommodating companion when you need someone (or a robot) to talk to.",
  },
]

const Features = () => {
  return (
    <div className="gpt3__features section__padding" id="features">
      <div className="gpt3__features-heading">
        <h1 className="gradient__text">
        The Future is Now and You Just Need To Realize It. Step into Future Today & Make it Happen.
        </h1>

        <p>Request Early Access</p>
      </div>

      <div className="gpt3__features-container">
        {featuresData.map((item)=>{
          return (

            <Feature title={item.title} text={item.text} structureClass={"row"}/>
          )
        })}
      </div>
    </div>
  )
}

export default Features